import { Injectable, signal } from '@angular/core';
import * as L from 'leaflet';
import { MapLayer } from '../interfaces';

export type PointId = number;

export interface TrackPoint {
  id: PointId;
  latlng: L.LatLng;
}

export interface TrackLine {
  id: number;
  points: TrackPoint[];
  pointMap: Map<PointId, L.LatLng>;
  layer: MapLayer;
}

export type Timeline = PointId[];

@Injectable()
export class TripPolylineTrackStoreService {
  private tracksSignal = signal<TrackLine[]>([]);
  private timeline: Timeline = [];

  setTimeline(t: Timeline): void {
    this.timeline = t;
  }

  addTrack(id: number, layer: MapLayer): void {
    if (!layer.extraData) return;

    const points: TrackPoint[] = (layer.extraData.polylineData || []).map(
      item => ({
        id: item.extraData!.id!,
        latlng: L.latLng(item.lat, item.lng),
      })
    );
    this.tracksSignal.update(list => [
      ...list,
      {
        id,
        points,
        pointMap: new Map(points.map(p => [p.id, p.latlng])),
        layer,
      },
    ]);
  }

  removeTrack(id: number): void {
    this.tracksSignal.update(list => {
      return list.filter(x => x.id !== id);
    });
  }

  updateVisibleBySlider(visibleIds: number[]): void {
    const activeIds = new Set(visibleIds);

    for (const track of this.tracksSignal()) {
      const visible: L.LatLng[] = [];

      for (const id of activeIds) {
        const p = track.pointMap.get(id);
        if (p) visible.push(p);
      }

      if (track.layer instanceof L.Polyline) {
        track.layer.setLatLngs(visible);
      }
    }
  }

  getTimelineLength(): number {
    return this.timeline.length;
  }
  clearTrackStore(): void {
    this.tracksSignal.set([]);
  }
}
